import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromFloor from './floor.reducer';
import { FloorState } from './floor.state';

// ============================================================================
// FLOOR SELECTORS
// ============================================================================
// Note: We will step away from using these selectors in the future, so don't
// add new ones or build upon them.
// ============================================================================

export const selectFloorState = createFeatureSelector<FloorState>('floors');

export const selectFloorIds = createSelector(selectFloorState, fromFloor.selectFloorIds);

export const selectFloorEntities = createSelector(selectFloorState, fromFloor.selectFloorEntities);

export const selectAllFloors = createSelector(selectFloorState, fromFloor.selectAllFloors);

export const selectFloors = (brandId: string, locationId: string) =>
  createSelector(selectAllFloors, (floors) =>
    floors ? floors.filter((floor) => floor.locationId === locationId) : []
  );

export const selectFloor = (brandId: string, locationId: string, floorId: string) =>
  createSelector(selectAllFloors, (floors) =>
    floors ? floors.find((floor) => floor.locationId === locationId && floor.id === floorId) : undefined
  );

export const hasFloor = (brandId: string, locationId: string, floorId: string) =>
  createSelector(selectFloor(brandId, locationId, floorId), (floor) => !!floor);
